// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Buefy from 'buefy';
import 'buefy/dist/buefy.css';
import VueRouter from 'vue-router';
import { ClientTable, ServerTable } from 'vue-tables-2';
import CKEditor from 'ckeditor4-vue';
import { PAGE_DEFAULT } from '@/router/routerConf';
import formatDate from '@/services/general/formatDate';
import formatLocaleString from '@/services/general/filters/formatLocaleString';
import 'cropperjs/dist/cropper.css';
import 'bulma-o-steps/bulma-steps.css';
import { datadogLogs } from '@datadog/browser-logs';

import { formatDevise } from '@/services/general/filters/formatDevise';
import gestionOnglet from '@/services/general/gestionOnglet';
import formatPercent from '@/services/general/filters/formatPercent';
import gestionSociete from '@/services/general/gestionSociete';
import textEditor from '@/components/general/global/textEditor';
import * as translate from './i18n/translate';
import initTranslate from './i18n/serviceTranslate';
import i18n from './i18n';
import Root from './Root';
import store from './store/store';
import registerStore from './store/registerStore';
import router from './router/index';
import {
  dateParser,
  LISTE_JOURS,
  LISTE_MOIS,
  JOUR_DEBUT_SEMAINE,
} from './configuration/datePickerConf';

import '@/components/qdEncapsulation/index';

Vue.use(VueRouter);
/* eslint-disable no-undef */
Vue.use(ClientTable, {}, false, 'bulma', 'default');
Vue.use(ServerTable, {}, false, 'bulma', 'default');
Vue.use(Buefy, {
  defaultDayNames: LISTE_JOURS,
  defaultMonthNames: LISTE_MOIS,
  defaultFirstDayOfWeek: JOUR_DEBUT_SEMAINE,
  defaultDateParser: date => dateParser(date),
  defaultDatepickerMobileNative: false,
});

Vue.use(CKEditor);

registerStore(store);

const messages = translate.TRANSLATE;
if (process.env.NODE_ENV === 'development') {
  initTranslate(messages.fr);
}

Vue.prototype.$PAGE_DEFAULT = PAGE_DEFAULT;

Vue.filter('formatSize', (size) => {
  if (size > 1024 * 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024 / 1024).toFixed(2) + ' TB';
  }
  if (size > 1024 * 1024 * 1024) {
    return (size / 1024 / 1024 / 1024).toFixed(2) + ' GB';
  }
  if (size > 1024 * 1024) {
    return (size / 1024 / 1024).toFixed(2) + ' MB';
  }
  if (size > 1024) {
    return (size / 1024).toFixed(2) + ' KB';
  }
  return size.toString() + ' B';
});

Vue.filter('formatDate', (date) => {
  return formatDate(date);
});

Vue.filter('formatDevise', (data) => {
  return formatDevise(data);
});

Vue.filter('formatPercent', (data) => {
  return formatPercent(data);
});

Vue.filter('formatLocaleString', (string) => {
  return formatLocaleString(string);
});

// bus
const bus = new Vue();
Vue.prototype.$bus = bus;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  i18n,
  router,
  store,
  render: h => h(Root),
});

Vue.mixin(gestionOnglet);
Vue.mixin(gestionSociete);

Vue.component('qd-text-editor', textEditor);

datadogLogs.init({
  clientToken: '9830fb1c3cc2ab72ba2e848984ef1534',
  site: 'datadoghq.eu',
  service: 'affixe_gescom_front',
  forwardErrorsToLogs: true,
  forwardConsoleLogs: 'all',
  env: process.env.NODE_ENV,
  sessionSampleRate: 100,
});
